// Translations for the StaffLanding page (post-login module launcher).
const staffLandingDict = [
  { en: "Welcome,", sw: "Karibu," },
  { en: "You have access to", sw: "Una ufikiaji wa" },
  { en: "module", sw: "moduli" },
  { en: "modules", sw: "moduli" },
  { en: "Search modules...", sw: "Tafuta moduli..." },
  { en: "No modules found", sw: "Hakuna moduli zilizopatikana" },
  { en: "No modules match", sw: "Hakuna moduli zinazolingana na" },
  { en: "You do not have access to any modules yet", sw: "Bado huna ufikiaji wa moduli yoyote" },
  { en: "Open →", sw: "Fungua →" },
  { en: "Member Management", sw: "Usimamizi wa Wanachama" },
  { en: "Financial", sw: "Fedha" },
  { en: "Communication", sw: "Mawasiliano" },
  { en: "Operations", sw: "Uendeshaji" },
  { en: "Administration", sw: "Utawala" },
  { en: "Other", sw: "Nyingine" },
];

export default staffLandingDict;
